"use client";

import { c as _c } from "react/compiler-runtime";
import { CircleCheck, Download } from "lucide-react";
import { Button } from "@/src/components/shadcn/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/src/components/shadcn/ui/tooltip";
interface FileDownloadButtonProps {
  disabledReason?: string;
  filename?: string;
  hasDownloaded?: boolean;
  href?: string;
  onClick?: () => void | Promise<void>;
}
function DownloadIcon(t0) {
  const $ = _c(2);
  const {
    hasDownloaded
  } = t0;
  let t1;
  if ($[0] !== hasDownloaded) {
    t1 = hasDownloaded ? <CircleCheck size={16} className="text-success" /> : <Download size={16} />;
    $[0] = hasDownloaded;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function FileDownloadButton(t0) {
  const $ = _c(20);
  const {
    disabledReason,
    filename,
    hasDownloaded,
    href,
    onClick
  } = t0;
  if (!disabledReason && href) {
    let t1;
    if ($[0] !== hasDownloaded) {
      t1 = <DownloadIcon hasDownloaded={hasDownloaded} />;
      $[0] = hasDownloaded;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== filename || $[3] !== href || $[4] !== t1) {
      t2 = <Button size="icon-sm" variant="ghost" asChild={true}><a href={href} download={filename} aria-label="Download file">{t1}</a></Button>;
      $[2] = filename;
      $[3] = href;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  const t1 = Boolean(disabledReason);
  const t2 = disabledReason ? `Download unavailable: ${disabledReason}` : "Download file";
  let t3;
  if ($[6] !== hasDownloaded) {
    t3 = <DownloadIcon hasDownloaded={hasDownloaded} />;
    $[6] = hasDownloaded;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onClick || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <Button type="button" size="icon-sm" variant="ghost" className="text-muted-foreground" disabled={t1} onClick={onClick} aria-label={t2}>{t3}</Button>;
    $[8] = onClick;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const button = t4;
  if (!disabledReason) {
    return button;
  }
  let t5;
  if ($[13] !== button) {
    t5 = <TooltipTrigger asChild={true}><span className="inline-flex cursor-not-allowed" tabIndex={0}>{button}</span></TooltipTrigger>;
    $[13] = button;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== disabledReason) {
    t6 = <TooltipContent>{disabledReason}</TooltipContent>;
    $[15] = disabledReason;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <TooltipProvider delayDuration={0}><Tooltip>{t5}{t6}</Tooltip></TooltipProvider>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}